import Row from './component';
// import styles from './styles';

export default Row;
